import { STORAGE_KEY } from '../constants';
import { sanitiseParams } from './params';

// localStorage can be missing (server render), blocked (privacy settings) or
// throw on access (some private windows), so every call is guarded and a failure
// simply means the values are held in memory only.
const getStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch (error) {
    return null;
  }
};

export function clearStoredAttribution() {
  const storage = getStorage();
  if (!storage) return false;
  try {
    storage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * The stored record, or null when there is none, it has expired or it does not
 * parse. Stored params are sanitised again on read since anything on the device
 * can be edited.
 */
export function readStoredAttribution({ now = Date.now() } = {}) {
  const storage = getStorage();
  if (!storage) return null;

  let raw;
  try {
    raw = storage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
  if (!raw) return null;

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (error) {
    clearStoredAttribution();
    return null;
  }

  const { params, capturedAt, expiresAt } = parsed || {};
  const cleanParams =
    params && typeof params === 'object' ? sanitiseParams(Object.entries(params)) : null;

  if (!cleanParams || typeof expiresAt !== 'number' || expiresAt <= now) {
    clearStoredAttribution();
    return null;
  }

  return { params: cleanParams, capturedAt, expiresAt };
}

export function writeStoredAttribution(record) {
  const storage = getStorage();
  if (!storage || !record) return false;
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(record));
    return true;
  } catch (error) {
    return false;
  }
}
